// Component for creating a travel list
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const CreateTravelList = () => {
    // State variables for managing form data and selected clothes
    const [clothes, setClothes] = useState([]);
    const [selectedClothes, setSelectedClothes] = useState([]);
    const [travelListName, setTravelListName] = useState('');
    const [destination, setDestination] = useState('');
    const [departureDate, setDepartureDate] = useState('');
    const [returnDate, setReturnDate] = useState('');
    const [description, setDescription] = useState('');
    const navigate = useNavigate();

    // Search state variables
    const [clothNameSearchTerm, setClothNameSearchTerm] = useState('');
    const [categorySearchTerm, setCategorySearchTerm] = useState('');
    const [colorSearchTerm, setColorSearchTerm] = useState('');
    const [seasonSearchTerm, setSeasonSearchTerm] = useState('');

    // Fetch clothing items
    useEffect(() => {
        fetchClothes();
    }, []);

    const fetchClothes = async () => {
        try {
            const response = await axios.get('http://localhost:3000/api/clothes', {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            setClothes(response.data);
        } catch (error) {
            console.error('Error fetching clothes:', error.response ? error.response.data : error.message);
        }
    };

    const handleClothSelect = (clothId) => {
        setSelectedClothes((prevSelected) =>
            prevSelected.includes(clothId)
                ? prevSelected.filter((id) => id !== clothId)
                : [...prevSelected, clothId]
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const travelListData = {
            list_name: travelListName,
            destination: destination.split(',').map(des => des.trim()),
            description: description,
            clothing_items: selectedClothes,
            departure_date: departureDate,
            return_date: returnDate
        };
    
        try {
            await axios.post('http://localhost:3000/api/travellists', travelListData, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            navigate('/travellists');  // Redirect to Travel Lists page after creation
        } catch (error) {
            console.error('Error creating travel list:', error.response ? error.response.data : error.message);
            alert('Error creating travel list. Please try again.');
        }
    };

    // Filter clothes based on search terms
    const filteredClothes = clothes.filter(cloth => {
        const matchesClothName = cloth.cloth_name.toLowerCase().includes(clothNameSearchTerm.toLowerCase());
        const matchesCategory = cloth.category.some(cat => cat.toLowerCase().includes(categorySearchTerm.toLowerCase()));
        const matchesColor = cloth.color.some(col => col.toLowerCase().includes(colorSearchTerm.toLowerCase()));
        const matchesSeason = cloth.season.some(sea => sea.toLowerCase().includes(seasonSearchTerm.toLowerCase()));

        return matchesClothName && matchesCategory && matchesColor && matchesSeason;
    });
    
    return (
        <div className="create-travel-list-container">
            <h2><strong>𝒞𝓇𝑒𝒶𝓉𝑒 𝒶 𝒯𝓇𝒶𝓋𝑒𝓁 𝐿𝒾𝓈𝓉</strong></h2>
            <form onSubmit={handleSubmit}>
                <label>
                    <strong>Name:</strong>
                    <input
                        type="text"
                        value={travelListName}
                        onChange={(e) => setTravelListName(e.target.value)}
                        placeholder="Enter travel list name"
                        required
                    />
                </label>
                <label>
                    <strong>Destination\-s:</strong>
                    <input
                        type="text"
                        value={destination}
                        onChange={(e) => setDestination(e.target.value)}
                        placeholder="e.g. Greece, Corfu (optional)"
                    />
                </label>
                <label>
                    <strong>Departure Date:</strong>
                    <input
                        type="date"
                        value={departureDate}
                        onChange={(e) => setDepartureDate(e.target.value)}
                    />
                </label>
                <label>
                    <strong>Return Date:</strong>
                    <input
                        type="date"
                        value={returnDate}
                        onChange={(e) => setReturnDate(e.target.value)}
                    />
                </label>
                <label>
                    <strong>Description:</strong>
                    <input
                        type="text"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="Describe where you are going and for what (optional)"
                    />
                </label>

                <div className="search-filters">
                    <h3><strong>𝒮𝑒𝒶𝓇𝒸𝒽 & 𝒮𝑒𝓁𝑒𝒸𝓉 𝒞𝓁𝑜𝓉𝒽𝑒𝓈:</strong></h3>
                    <input
                        type="text"
                        placeholder="Search by cloth name"
                        value={clothNameSearchTerm}
                        onChange={(e) => setClothNameSearchTerm(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Search by category"
                        value={categorySearchTerm}
                        onChange={(e) => setCategorySearchTerm(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Search by color"
                        value={colorSearchTerm}
                        onChange={(e) => setColorSearchTerm(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Search by season"
                        value={seasonSearchTerm}
                        onChange={(e) => setSeasonSearchTerm(e.target.value)}
                    />
                </div>

                <div className="clothing-list">
                    {filteredClothes.map((cloth) => (
                        <div
                            key={cloth._id}
                            className={`clothing-item ${selectedClothes.includes(cloth._id) ? 'selected' : ''}`}
                            onClick={() => handleClothSelect(cloth._id)}
                        >
                            <img src={cloth.image_url} alt={cloth.cloth_name} />
                            <label>{cloth.cloth_name}</label>
                        </div>
                    ))}
                </div>

                <button type="submit" className="create-btn"><i className="fa-solid fa-plus"></i> <strong>𝒞𝓇𝑒𝒶𝓉𝑒</strong></button>
            </form>
        </div>
    );
};

export default CreateTravelList;